// extracted by mini-css-extract-plugin
export default {"otpContainer":"EmailOTP_otpContainer__7aVD6"};